"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const useFormValidationState = require("../../../../../chunks/useFormValidationState-DUZahEdK.js");
const clsx = require("../../../../../chunks/clsx-CBkIpawf.js");
const components_input_elements_unstyled_CheckboxBase_hooks_useCheckboxContext = require("./hooks/useCheckboxContext.js");
const helpers_module = require("../../../../../chunks/helpers.module-CyAR4a3K.js");
const FocusRing_module = require("../../../../../chunks/FocusRing.module-CTvWELtH.js");
const useFocusRing = require("../../../../../chunks/useFocusRing-014cPU2v.js");
const mergeProps = require("../../../../../chunks/mergeProps-AWQ5Mc81.js");
const useFormValidation = require("../../../../../chunks/useFormValidation-Dodhyml1.js");
const usePress = require("../../../../../chunks/usePress-CQi4MPVm.js");
const filterDOMProps = require("../../../../../chunks/filterDOMProps-DSqQIo6b.js");
const useFocusable = require("../../../../../chunks/useFocusable-3KL9EmBS.js");
const utils = require("../../../../../chunks/utils-Y4id5lfu.js");
function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
  let { isDisabled = false, isReadOnly = false, value, name, form, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, validationState = "valid", isInvalid, onPressStart, onPressEnd, onPressChange, onPress, onPressUp, onClick } = props;
  let onChange = (e) => {
    e.stopPropagation();
    state.setSelected(e.target.checked);
  };
  let hasChildren = children != null;
  let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel && process.env.NODE_ENV !== "production") console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps, isPressed } = usePress.$f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    onPressUp,
    onClick,
    isDisabled
  });
  let { pressProps: labelProps, isPressed: isLabelPressed } = usePress.$f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPressUp,
    onClick,
    onPress(e) {
      var _ref_current;
      onPress === null || onPress === void 0 ? void 0 : onPress(e);
      state.toggle();
      (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    },
    isDisabled: isDisabled || isReadOnly
  });
  let { focusableProps } = useFocusable.$f645667febf57a63$export$4c014de7c8940b4c(props, ref);
  let interactions = mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  let domProps = filterDOMProps.$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  useFormValidation.$99facab73266f662$export$5add1d006293d136(ref, state.defaultSelected, state.setSelected);
  return {
    labelProps: mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, {
      onClick: (e) => e.preventDefault()
    }),
    inputProps: mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      "aria-invalid": isInvalid || validationState === "invalid" || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-controls": props["aria-controls"],
      "aria-readonly": isReadOnly || void 0,
      onChange,
      disabled: isDisabled,
      ...value == null ? {} : {
        value
      },
      name,
      form,
      type: "checkbox",
      ...interactions
    }),
    isSelected: state.isSelected,
    isPressed: isPressed || isLabelPressed,
    isDisabled,
    isReadOnly,
    isInvalid: isInvalid || validationState === "invalid"
  };
}
function $406796ff087fe49b$export$e375f10ce42261c5(props, state, inputRef) {
  let validationState = useFormValidationState.$e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: state.isSelected
  });
  let { isInvalid, validationErrors, validationDetails } = validationState.displayValidation;
  let { labelProps, inputProps, isSelected, isPressed, isDisabled, isReadOnly } = $d2c8e2b0480f3f34$export$cbe85ee05b554577({
    ...props,
    isInvalid
  }, state, inputRef);
  useFormValidation.$e93e671b31057976$export$b8473d3665f3a75a(props, validationState, inputRef);
  let { isIndeterminate, isRequired, validationBehavior = "aria" } = props;
  React.useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
  });
  let { pressProps } = usePress.$f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled: isDisabled || isReadOnly,
    onPress() {
      let { [useFormValidationState.$e5be200c675c3b3a$export$a763b9476acd3eb]: groupValidationState } = props;
      let { commitValidation } = groupValidationState ? groupValidationState : validationState;
      commitValidation();
    }
  });
  return {
    labelProps: mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, pressProps),
    inputProps: {
      ...inputProps,
      checked: isSelected,
      "aria-required": isRequired && validationBehavior === "aria" || void 0,
      required: isRequired && validationBehavior === "native"
    },
    isSelected,
    isPressed,
    isDisabled,
    isReadOnly,
    isInvalid,
    validationErrors,
    validationDetails
  };
}
function $3017fa7ffdddec74$export$8042c6c013fd5226(props = {}) {
  let { isReadOnly } = props;
  let [isSelected, setSelected] = useFormValidationState.$458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isSelected, props.defaultSelected || false, props.onChange);
  let [initialValue] = React.useState(isSelected);
  function updateSelected(value) {
    if (!isReadOnly) setSelected(value);
  }
  function toggleState() {
    if (!isReadOnly) setSelected(!isSelected);
  }
  var _props_defaultSelected;
  return {
    isSelected,
    defaultSelected: (_props_defaultSelected = props.defaultSelected) !== null && _props_defaultSelected !== void 0 ? _props_defaultSelected : initialValue,
    setSelected: updateSelected,
    toggle: toggleState
  };
}
function $fba3e38d5ca8983f$export$353b32fc6898d37d(props, state, inputRef) {
  const toggleState = $3017fa7ffdddec74$export$8042c6c013fd5226({
    isReadOnly: props.isReadOnly || state.isReadOnly,
    isSelected: state.isSelected(props.value),
    defaultSelected: state.defaultValue.includes(props.value),
    onChange(isSelected) {
      if (isSelected) state.addValue(props.value);
      else state.removeValue(props.value);
      if (props.onChange) props.onChange(isSelected);
    }
  });
  let { name, form, descriptionId, errorMessageId, validationBehavior } = utils.$1ae600c947479353$export$ec98120685d4f57d.get(state);
  var _props_validationBehavior;
  validationBehavior = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : validationBehavior;
  let { realtimeValidation } = useFormValidationState.$e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: toggleState.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  });
  let nativeValidation = React.useRef(useFormValidationState.$e5be200c675c3b3a$export$dad6ae84456c676a);
  let updateValidation = () => {
    state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
  };
  React.useEffect(updateValidation);
  let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
  let displayValidation = validationBehavior === "native" ? state.displayValidation : combinedRealtimeValidation;
  var _props_isRequired;
  let res = $406796ff087fe49b$export$e375f10ce42261c5({
    ...props,
    isReadOnly: props.isReadOnly || state.isReadOnly,
    isDisabled: props.isDisabled || state.isDisabled,
    name: props.name || name,
    form: props.form || form,
    isRequired: (_props_isRequired = props.isRequired) !== null && _props_isRequired !== void 0 ? _props_isRequired : state.isRequired,
    validationBehavior,
    [useFormValidationState.$e5be200c675c3b3a$export$a763b9476acd3eb]: {
      realtimeValidation: combinedRealtimeValidation,
      displayValidation,
      resetValidation: state.resetValidation,
      commitValidation: state.commitValidation,
      updateValidation(v) {
        nativeValidation.current = v;
        updateValidation();
      }
    }
  }, toggleState, inputRef);
  return {
    ...res,
    inputProps: {
      ...res.inputProps,
      "aria-describedby": [
        props["aria-describedby"],
        state.isInvalid ? errorMessageId : null,
        descriptionId
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
const StandaloneCheckbox = React.forwardRef((props, ref) => {
  const {
    className,
    focusedClassName,
    pressedClassName,
    selectedClassName,
    isSelected,
    defaultSelected,
    id,
    ...restProps
  } = props;
  const inputRef = React.useRef(null);
  const { focusProps, isFocusVisible } = useFocusRing.$f7dceffc5ad7768b$export$4e328f61c538687f();
  const toggleState = $3017fa7ffdddec74$export$8042c6c013fd5226({
    ...restProps,
    isSelected,
    defaultSelected
  });
  const { labelProps, inputProps, isPressed } = $406796ff087fe49b$export$e375f10ce42261c5(
    restProps,
    toggleState,
    inputRef
  );
  return /* @__PURE__ */ jsxRuntime.jsxs(
    "label",
    {
      className: clsx.clsx(className, {
        [selectedClassName || ""]: toggleState.isSelected,
        [pressedClassName || ""]: isPressed,
        [focusedClassName || ""]: isFocusVisible,
        [FocusRing_module.focus.focusRing]: isFocusVisible
      }),
      id,
      ...labelProps,
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(
          "input",
          {
            ...mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps),
            ref: ref || inputRef,
            className: helpers_module.helpers.srOnly
          }
        ),
        props.children
      ]
    }
  );
});
const GroupCheckbox = React.forwardRef((props, ref) => {
  const { className, focusedClassName, pressedClassName, selectedClassName, id, ...restProps } = props;
  const inputRef = React.useRef(null);
  const { focusProps, isFocusVisible } = useFocusRing.$f7dceffc5ad7768b$export$4e328f61c538687f();
  const groupContext = components_input_elements_unstyled_CheckboxBase_hooks_useCheckboxContext.useCheckboxGroupProvider();
  const { labelProps, inputProps, isSelected, isPressed } = $fba3e38d5ca8983f$export$353b32fc6898d37d(
    restProps,
    groupContext.state,
    inputRef
  );
  return /* @__PURE__ */ jsxRuntime.jsxs(
    "label",
    {
      className: clsx.clsx(className, {
        [selectedClassName || ""]: isSelected,
        [pressedClassName || ""]: isPressed,
        [focusedClassName || ""]: isFocusVisible,
        [FocusRing_module.focus.focusRing]: isFocusVisible
      }),
      id,
      ...labelProps,
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(
          "input",
          {
            ...mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps),
            ref: ref || inputRef,
            className: helpers_module.helpers.srOnly
          }
        ),
        props.children
      ]
    }
  );
});
const CheckboxBase = React.forwardRef(
  (props, ref) => {
    const groupContext = components_input_elements_unstyled_CheckboxBase_hooks_useCheckboxContext.useCheckboxGroupProvider();
    const isInGroup = !!groupContext;
    if (isInGroup) {
      return /* @__PURE__ */ jsxRuntime.jsx(GroupCheckbox, { ...props, ref });
    } else {
      return /* @__PURE__ */ jsxRuntime.jsx(StandaloneCheckbox, { ...props, ref });
    }
  }
);
exports.CheckboxBase = CheckboxBase;
